const HeaderItems = [
    {
        label: " Customer Message Triggers",
        link: "#/",
        activeNav: "tab_eventlogs",
        subNavItems: []
    },
    {
        label: "Customer Messages",
        link: "#/CustomerMessages",
        activeNav: "tab_generatedmessage",
        subNavItems: []
    }
];

export default HeaderItems;
